import { render } from "./ModelNotFound.vue?vue&type=template&id=435f161f&scoped=true&ts=true"
import script from "./ModelNotFound.vue?vue&type=script&lang=ts"
export * from "./ModelNotFound.vue?vue&type=script&lang=ts"

import "./ModelNotFound.vue?vue&type=style&index=0&id=435f161f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-435f161f"]])

export default __exports__